export const BASE_URI = "https://oridsan-server.fly.dev/api/v1";
